"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginRequest = void 0;
var LoginRequest = /** @class */ (function () {
    function LoginRequest() {
        this.password = '9c92faec499e1183ce05fce753ff894d';
        this.userCode = '18516500680';
        this.registrationID = '';
        this.uniqueId = '';
    }
    return LoginRequest;
}());
exports.LoginRequest = LoginRequest;
;
//# sourceMappingURL=login.request.js.map